import { Box, Link, Stack, Typography } from '@mui/material';
import type { NodeOutput } from '../../../types/flow-execution.types';
import Section from './Section';
import { resolveEdgeField } from './resolveEdgeField';

interface Props {
  data: NodeOutput;
}

interface FileLink {
  src?: string;
  name?: string;
}

function OutputControllerPanel({ data }: Props) {
  const input = (data.input ?? {}) as Record<string, unknown>;
  const output = (data.outputData ?? {}) as Record<string, unknown>;
  const resolvedInput = resolveEdgeField(input.text, input.textData);
  const outputText =
    (output.text as string | undefined) ?? data.output ?? undefined;
  const errorMessage = output.errorMessage as string | undefined;
  const fileLink = output.fileLink as FileLink | undefined;
  return (
    <Stack spacing={1.5}>
      <Section title='Input'>
        {resolvedInput.length === 0 ? (
          <Typography variant='caption' color='text.secondary'>
            No input provided.
          </Typography>
        ) : (
          <Box>{resolvedInput}</Box>
        )}
      </Section>
      <Section title='Output'>
        {data.isError ? (
          <Typography variant='body2' color='error'>
            {errorMessage || 'Node execution failed.'}
          </Typography>
        ) : outputText ? (
          outputText
        ) : (
          <Typography variant='caption' color='text.secondary'>
            No output produced.
          </Typography>
        )}
      </Section>
      {fileLink?.src && (
        <Section title='File'>
          <Link
            href={fileLink.src}
            target='_blank'
            rel='noopener noreferrer'
            underline='hover'
          >
            {fileLink.name || fileLink.src}
          </Link>
        </Section>
      )}
    </Stack>
  );
}

export default OutputControllerPanel;
